import {adapter} from "./adapter";

export const servicioGuardarCotizacionRepuestos = (bodyRequest) => {
    const endPoint = `/api/repuestos/cotizacion/guardar`
    return adapter(endPoint, "POST", bodyRequest);
};

export const servicioGuardarInteresadoCampania = (bodyRequest) => {
    const endPoint = `/api/postventa/campania`
    return adapter(endPoint, "POST", bodyRequest);
};

